// reducers/sharedSafariReducer.js

export const initialParksState = {
    parksData: [],
    summary: {},
    filters: {},
    pageIndex: 1,
    animalSearch: '',
    parkSearch: '',
    filterdPark: [],
    selectedPark: 0,
    //rare animal listing
    raParkData: [],
    raSummary: {},
    raFilters: {},
    raPageIndex: 1
};

export const parksReducer = (state = initialParksState, action) => {
    switch (action.type) {
        case 'SET_PARKS_DATA':
            return {
                ...state,
                parksData: Array.isArray(action.payload)
                    ? action.payload
                    : state.parksData,
            };

        case 'APPEND_PARKS_DATA':
            const existingIds = new Set(state.parksData.map(p => p.id));
            const newUniqueParks = action.payload.filter(p => !existingIds.has(p.id));

            return {
                ...state,
                parksData: [...state.parksData, ...newUniqueParks],
            };
        case 'PARKS_SUMMARY':
            return {
                ...state,
                summary: action.payload && typeof action.payload === 'object'
                    ? action.payload
                    : state.summary,
            };

        case 'SET_PAGE_INDEX':
            return {
                ...state,
                pageIndex: typeof action.payload === 'number' && !isNaN(action.payload)
                    ? action.payload
                    : state.pageIndex,
            };
        case 'SET_ANIMAL_SEARCH':
            return {
                ...state,
                animalSearch:
                    typeof action.payload === 'string' && action.payload.trim().length > 0
                        ? action.payload
                        : "",
            };
        case 'SET_PARK_SEARCH':
            return {
                ...state,
                parkSearch:
                    typeof action.payload === 'string' && action.payload.trim().length > 0
                        ? action.payload
                        : "",
            };
        case 'SET_FILTERD_PARK_DATA':
            return {
                ...state,
                filterdPark: Array.isArray(action.payload)
                    ? action.payload
                    : state.filterdPark,
            };

        case 'SET_SELECTED_PARK':
            return {
                ...state,
                selectedPark: typeof action.payload === 'number' && !isNaN(action.payload)
                    ? action.payload
                    : state.selectedPark,
            };

        case 'SET_PARKS_FILTERS':
            return {
                ...state,
                filters: action.payload && typeof action.payload === 'object'
                    ? action.payload
                    : state.filters,
            };

        case 'UPDATE_PARKS_FILTER':
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...(action.payload && typeof action.payload === 'object' ? action.payload : {}),
                },
            };

        //Rare Animals
        case 'SET_RA_PARKS_DATA':
            return {
                ...state,
                raParkData: Array.isArray(action.payload)
                    ? action.payload
                    : state.raParkData,
            };

        case 'APPEND_RA_PARKS_DATA':
            const existingRaIds = new Set(state.raParkData.map(p => p.id));
            const newUniqueRaParks = action.payload.filter(p => !existingRaIds.has(p.id));

            return {
                ...state,
                raParkData: [...state.raParkData, ...newUniqueRaParks],
            };
        case 'RA_PARKS_SUMMARY':
            return {
                ...state,
                raSummary: action.payload && typeof action.payload === 'object'
                    ? action.payload
                    : state.raSummary,
            };

        case 'SET_RA_PAGE_INDEX':
            return {
                ...state,
                raPageIndex: typeof action.payload === 'number' && !isNaN(action.payload)
                    ? action.payload
                    : state.raPageIndex,
            };
        case 'SET_RA_PARKS_FILTERS':
            return {
                ...state,
                filters: action.payload && typeof action.payload === 'object'
                    ? action.payload
                    : state.filters,
            };

        case 'UPDATE_RA_PARKS_FILTER':
            return {
                ...state,
                raFilters: {
                    ...state.raFilters,
                    ...(action.payload && typeof action.payload === 'object' ? action.payload : {}),
                },
            };

        default:
            return state;
    }
};
